




import Vue from 'vue';
import Component from 'vue-class-component';
import authApi from '@/api/auth.api';
import * as types from '@/store/types';
import { AccountRole } from '@/entities/accounts/account-role.enum';
import { mapGetters } from 'vuex';
import ProfileOffice from '@/containers/account/profile/profile-office.vue';
import ProfileAgent from '@/containers/account/profile/profile-agent.vue';
import ProfileAdmin from '@/containers/account/profile/profile-admin.vue';

@Component({
  computed: mapGetters({
    role: types.AUTH_GET_ROLE
  })
})
export default class ProfileContainer extends Vue {
  protected role: number;

  get currentProfileComponent() {
    switch (this.role) {
      case AccountRole.Agent:
        return ProfileAgent;
      case AccountRole.Company:
        return ProfileOffice;
      case AccountRole.Superadmin:
      case AccountRole.Admin:
        return ProfileAdmin;
    }
  }
}
